<template>
  <v-container
    fluid
  >
    <v-row>
      <v-col
        cols="12"
        xs="12"
        sm="12"
        md="6"
        lg="6"
        xl="6"
      >
        <Postfach_New></Postfach_New>
      </v-col>
      <v-col
        cols="12"
        xs="12"
        sm="12"
        md="6"
        lg="6"
        xl="6"
      >
        <SDSEditor
          :new_sds="new_sds"
        ></SDSEditor>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Postfach_New from "../components/MessageCenter/Postfach_New";
import SDSEditor from "../components/MessageCenter/SDSEditor";
export default {
  name: "MessageCenter",
  components: { Postfach_New, SDSEditor },
  data: () => ({
    new_sds: {
      receiver: [],
      text: '',
      flash_sds: false,
      copy_to_station: false
    },
  }),
};
</script>

<style scoped>

</style>
